export * from './information-summaries.component';
